import { combineReducers } from 'redux';
import { authReducer } from './authReducer';
import { orderReducer } from './orderReducer';
import { userReducer } from './userReducer';
import { storeReducer } from './storeReducer';
import { productReducer } from './productReducer';
import { companyReducer } from './companyReducer';

export const rootReducer = combineReducers({
  Auth: authReducer,
  Order: orderReducer,
  User: userReducer,
  Store: storeReducer,
  Product: productReducer,
  Company: companyReducer,
});

export type AppState = ReturnType<typeof rootReducer>;
